/**
 * 가이드북
 */
import { Fragment } from 'react';
import { useLoaderData } from 'react-router-dom';
import Header from '@features/content/Header';
import FilterWrap from '@components/contents/common/FilterWrap';
import NoData from '@components/contents/common/NoData';
import { apiSearchSlice } from '@features/api/apiSearchSlice';
import { ALIAS, CUR_NETWORK, FILTER_DATA, NETWORK, SERVICE_ALIAS, GAME_NAME, SEARCH_PARAMS } from '@constants/index';
import { setRequestToSearchParams } from '@utils/index';
import { useOption } from '@hooks/useOption';
import { getLocalData } from '@features/api/apiLocalSlice';
import { useAppSelector } from '@hooks/defineRtkTypedHook';
import { selectL10N, setAlias } from '@features/ui/UiSlice';
import GuidebookArticle from '@components/contents/article/GuideBookArticle';
import Paging from '@components/contents/common/Paging';
import type { ILoaderData, IGuidebook, IContentData } from '@type/index';

export const GuidebookLoader =
  (dispatch, option: IOption) =>
  async ({ request }): Promise<IGuidebook | null> => {
    const searchParams = setRequestToSearchParams(request);
    let cloneOption = { ...option };
    

    // alias 변경 - searchParams 변경에 사용됨
    dispatch(setAlias(ALIAS.GUIDEBOOK));

    if (!searchParams?.keyword) {
      return null;
    }

    for (let key in searchParams) {
      !searchParams[key] && delete searchParams[key]; // serverId 등 string으로 보내면 안됨
    }

    const { serviceAlias } = option || {};

    // 블소 - api 호출 시 gameName params 제거 (단, url searchParams에선 서버 타입 구분 위해 gameName 살려둠)
    if(serviceAlias === SERVICE_ALIAS.BNS) {
      const gameName = searchParams?.[SEARCH_PARAMS.GAME_NAME];
      cloneOption = {...cloneOption, serviceAlias: gameName ?? GAME_NAME[SERVICE_ALIAS.BNS].NEO};
      delete searchParams?.[SEARCH_PARAMS.GAME_NAME];
    }

    return CUR_NETWORK === NETWORK.OPDEV
      ? await getLocalData(ALIAS.GUIDEBOOK, searchParams)
      : await dispatch(apiSearchSlice?.endpoints?.getGuidebook?.initiate({ option: cloneOption, params: searchParams }));
  };

const FilterComponent = ({ count }: { count: number }) => {
  const { serviceAlias } = useOption();

  return (
    <Header totalCount={count}>
      <FilterWrap filterDataObj={serviceAlias ? FILTER_DATA[serviceAlias][ALIAS.GUIDEBOOK] : {}} />
    </Header>
  );
};

const ContentComponent = ({ data }: { data: IContentData<IGuidebook> }) => {
  const l10n = useAppSelector(selectL10N);
  const { endPage } = data?.pagination || {};

  return (
    <Fragment>
      <div className="search-content">
        <ul className="column column-2">
          {data?.list.map((item, i) => (
            <li key={item?.id} className="search-item">
              <GuidebookArticle item={item} l10n={l10n!} />
            </li>
          ))}
        </ul>
      </div>
      <Paging endPage={endPage} showPage={5} l10n={l10n!} />
    </Fragment>
  );
};

const Guidebook = () => {
  const { data, isLoading, isError } = (useLoaderData() as ILoaderData<IContentData<IGuidebook>>) || {};

  return (
    <div className="search-result guidebook">
      <FilterComponent count={data?.pagination?.total} />
      {!isError && Array.isArray(data?.list) && data?.list?.length > 0 ? <ContentComponent data={data} /> : <NoData />}
    </div>
  );
};

export default Guidebook;
